import { createBrowserRouter, Navigate } from "react-router-dom";
import { ActivitiesFilterDatePage } from "web_myplann/Activities/Filters/Pages/ActivitiesFilterDatePage";
import { ActivitiesFilterSimplePage } from "web_myplann/Activities/Filters/Pages/ActivitiesFilterSimplePage";
import { ActivitiesFiltersListPage } from "web_myplann/Activities/Filters/Pages/ActivitiesFiltersListPage";
import { ActivitiesListPage } from "web_myplann/Activities/Pages/ActivitiesListPage";
import { ActivityDetailPage } from "web_myplann/Activities/Pages/ActivityDetailPage";
import { DashboardDetailPage } from "web_myplann/Dashboard/Pages/DashboardDetailPage";
import { DashboardPage } from "web_myplann/Dashboard/Pages/DashboardPage";
import { NotificationPage } from "web_myplann/Dashboard/Pages/NotificationPage";
import { ExpensesPage } from "web_myplann/Finances/Pages/ExpensesPage";
import { FinancesIntro } from "web_myplann/Finances/Pages/FinancesIntro";
import { FinancesOverview } from "web_myplann/Finances/Pages/FinancesOverview";
import { IncomePage } from "web_myplann/Finances/Pages/IncomePage";
import { GoalForm } from "web_myplann/Goals/Pages/GoalForm";
import { GoalsList } from "web_myplann/Goals/Pages/GoalsList";
import { Error404Page } from "web_myplann/Infrastructure/Pages/Error404Page";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { getRoute } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { MorePage } from "web_myplann/More/Pages/MorePage";
import { SecurityPage } from "web_myplann/More/Pages/SecurityPage";
import { ToolHistory } from "web_myplann/Portfolio/Components/PortfolioTools/ToolHistory";
import { FolderDetailPage } from "web_myplann/Portfolio/Pages/FolderDetailPage";
import { PortfolioDetailPage } from "web_myplann/Portfolio/Pages/PortfolioDetailPage";
import { PortfolioPage } from "web_myplann/Portfolio/Pages/PortfolioPage";
import { AddressesPage } from "web_myplann/Profile/Pages/AddressesPage";
import { PaperworkPage } from "web_myplann/Profile/Pages/PaperworkPage";
import { PersonalDataAndAccountsPage } from "web_myplann/Profile/Pages/PersonalDataAndAccountsPage";
import { ProfilePage } from "web_myplann/Profile/Pages/ProfilePage";
import { SettingsPage } from "web_myplann/Profile/Pages/SettingsPage";
import { MyPlannAuthenticatedRoute } from "web_myplann/Shared/MyPlannAuthenticatedRoute";
import { StandalonePortfolioListWrapper } from "web_myplann/Standalone/StandalonePortfolioListWrapper";
import { TaskDetailPage } from "web_myplann/Tasks/Pages/TaskDetailPage";

export const routes = [
	{
		path: getRoute(Routing.ActivitiesFiltersCreated),
		element: (
			<MyPlannAuthenticatedRoute>
				<ActivitiesFilterSimplePage type="created" />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.ActivitiesFiltersType),
		element: (
			<MyPlannAuthenticatedRoute>
				<ActivitiesFilterSimplePage type="types" />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.ActivitiesFiltersDate),
		element: (
			<MyPlannAuthenticatedRoute>
				<ActivitiesFilterDatePage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.ActivitiesFilters),
		element: (
			<MyPlannAuthenticatedRoute>
				<ActivitiesFiltersListPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.ActivitiesList),
		element: (
			<MyPlannAuthenticatedRoute>
				<ActivitiesListPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.ActivityDetail),
		element: (
			<MyPlannAuthenticatedRoute>
				<ActivityDetailPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.TaskDetail),
		element: (
			<MyPlannAuthenticatedRoute>
				<TaskDetailPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.StandAlone),
		element: (
			<MyPlannAuthenticatedRoute>
				<StandalonePortfolioListWrapper />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Portfolio.PortfolioList),
		element: (
			<MyPlannAuthenticatedRoute>
				<PortfolioPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Portfolio.PortfolioDetail),
		element: (
			<MyPlannAuthenticatedRoute>
				<PortfolioDetailPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Profile.ProfileDetail),
		element: (
			<MyPlannAuthenticatedRoute>
				<ProfilePage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Profile.PersonalDataAndAccounts),
		element: (
			<MyPlannAuthenticatedRoute>
				<PersonalDataAndAccountsPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Profile.Addresses),
		element: (
			<MyPlannAuthenticatedRoute>
				<AddressesPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Profile.Paperwork),
		element: (
			<MyPlannAuthenticatedRoute>
				<PaperworkPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Profile.More),
		element: (
			<MyPlannAuthenticatedRoute>
				<MorePage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Profile.Security),
		element: (
			<MyPlannAuthenticatedRoute>
				<SecurityPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Profile.Settings),
		element: (
			<MyPlannAuthenticatedRoute>
				<SettingsPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.DashboardDetail),
		element: (
			<MyPlannAuthenticatedRoute>
				<DashboardDetailPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Finances.Intro),
		element: (
			<MyPlannAuthenticatedRoute>
				<FinancesIntro />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Finances.Income),
		element: (
			<MyPlannAuthenticatedRoute>
				<IncomePage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Finances.Expenses),
		element: (
			<MyPlannAuthenticatedRoute>
				<ExpensesPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Finances.Overview),
		element: (
			<MyPlannAuthenticatedRoute>
				<FinancesOverview />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Portfolio.PortfolioDetailHistory),
		element: (
			<MyPlannAuthenticatedRoute>
				<ToolHistory />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Portfolio.FolderDetail),
		element: (
			<MyPlannAuthenticatedRoute>
				<FolderDetailPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Notifications),
		element: (
			<MyPlannAuthenticatedRoute>
				<NotificationPage />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Goals.GoalsList),
		element: (
			<MyPlannAuthenticatedRoute>
				<GoalsList />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Goals.GoalFormCreate),
		element: (
			<MyPlannAuthenticatedRoute>
				<GoalForm />
			</MyPlannAuthenticatedRoute>
		),
	},
	{
		path: getRoute(Routing.Goals.GoalFormEdit),
		element: (
			<MyPlannAuthenticatedRoute>
				<GoalForm />
			</MyPlannAuthenticatedRoute>
		),
	},
];

const baseRoutes = [
	{
		index: true,
		element: <Navigate to={getRoute(Routing.Dashboard)} replace />,
	},
	{
		path: Routing.Dashboard.path(),
		element: (
			<MyPlannAuthenticatedRoute>
				<DashboardPage />
			</MyPlannAuthenticatedRoute>
		),
	},
];

export const getRouter = () =>
	createBrowserRouter(
		[...baseRoutes, ...routes, { path: "*", element: <Error404Page /> }],
		{
			basename: import.meta.env.VITE_BASE_URL?.replace(/\/$/, ""),
		},
	);
